import { useEffect, useState } from "react";
import { useAvailableModules } from "shared/api/hooks/useAvailableModules";

const useFixedAcceptorEmail = (costCentre, excludedEmails = []) => {
  const { data: modules } = useAvailableModules();

  const [fixedAcceptorEmail, setFixedAcceptorEmail] = useState(null);

  useEffect(() => {
    const fixedAdditionalAcceptorModule =
      modules?.user_modules?.FixedAdditionalAcceptor;

    if (!fixedAdditionalAcceptorModule?.available || !costCentre) return;

    const additionalAcceptorEmail =
      fixedAdditionalAcceptorModule?.additional_data?.find(
        ({ cost_centre_patterns }) =>
          cost_centre_patterns.some((pattern) =>
            costCentre
              .slice(0, pattern.length - 1)
              .includes(pattern.slice(0, pattern.length - 1))
          )
      )?.additional_acceptor_email;

    const excludedEmailsToLowerCase = excludedEmails?.map((email) =>
      email?.toLowerCase()
    );

    if (
      additionalAcceptorEmail !== undefined &&
      !excludedEmailsToLowerCase?.includes(
        additionalAcceptorEmail?.toLowerCase()
      )
    ) {
      setFixedAcceptorEmail(additionalAcceptorEmail);
    } else {
      setFixedAcceptorEmail(null);
    }
  }, [modules, costCentre, excludedEmails]);

  return fixedAcceptorEmail;
};

export default useFixedAcceptorEmail;
